<template>
  <b-col class="report-container d-flex flex-column flex-grow-1">
    <chromatography-flex-table-title
      :method="data.method"
      :norm="norm"
      :hasAlarms="data.alarmed"
      :executed="data.executed"
    />
    <div class="report-container__triangle-container">
      <div class="report-container__triangle-title text-center font-weight-bold">
        {{ translate('triangle') }}
      </div>
      <div class="text-center">
        <polygonal-chart
          class="duval-card__chart"
          no-subtitle
          size="small"
          :value="coordinates"
          :type="type"
        />
      </div>
      <div class="text-center">
        <div
          class="report-container__triangle-title text-center font-weight-bold"
        >
          {{ translate('points-coordinates') }}
        </div>
        <div class="text-center px-2 py-1">
          <slot name="coordinates"></slot>
        </div>
      </div>
      <div
        v-if="recommendations.length"
        class="report-container__classification-report-wrapper text-center"
      >
        <div class="report-container__right-bordered">
          <div class="report-container__triangle-title text-center font-weight-bold">
            {{ $t('general.classification') }}
          </div>
          <div class="text-center px-2 py-1">
            <template v-if="data.data.diagnostics.length">
              <p
                v-for="diagnostic in diagnostics"
                :key="diagnostic.description"
              >{{ $t(classificationLabel(diagnostic)) }}
              </p>
            </template>
          </div>
        </div>
        <div>
          <div class="report-container__triangle-title text-center font-weight-bold">
            {{ $t('engineering.report') }}
          </div>
          <div class="text-center px-2 py-1">
            <template v-if="data.data.diagnostics.length">
              <p
                v-for="diagnostic in diagnostics"
                :key="diagnostic.description"
              >{{ diagnostic.description }}</p>
            </template>
            <span v-else>{{ $t('engineering.not-exceed-minimum') }}</span>
          </div>
        </div>
      </div>
      <div class="text-center">
        <div
          v-if="recommendations.length"
          class="report-container__triangle-title text-center font-weight-bold"
        >
          {{ $t('general.recommendations') }}
        </div>
        <div class="text-center px-2 py-1">
          <p
            v-for="(recommendations, index) in recommendations"
            :key="index"
          >
            {{ recommendation }}
          </p>
        </div>
      </div>
    </div>
  </b-col>
</template>

<script>
import { ClassificationType } from 'sigma-mappings';
import ChromatographyFlexTableTitle from '@/domain/components/installation/engineering/chromatography/methodsAndDiagnostics/individualAnalysis/ChromatographyFlexTableTitle';
import PolygonalChart from '@/domain/components/installation/engineering/chromatography/polygonalChart';

export default {
  name: 'GenericTrianglePrint',
  props: {
    data: Object,
    norm: String,
    coordinates: Object,
    type: String,
  },
  components: {
    ChromatographyFlexTableTitle,
    PolygonalChart,
  },
  computed: {
    diagnostics() {
      return this.data.data.diagnostics || [];
    },
    recommendations() {
      return this.data.data.recommendations || [];
    },
  },
  methods: {
    classificationLabel({ classification }) {
      const classificationTypes = {
        [ClassificationType.ORDINARY]: 'enums.commons.classification-type.ordinary',
        [ClassificationType.URGENT]: 'enums.commons.classification-type.urgent',
        [ClassificationType.CRITICAL]: 'enums.commons.classification-type.critical',
        [ClassificationType.OBSERVATION]: 'enums.commons.classification-type.observation',
      };
      return classificationTypes[classification];
    },
    translate(key) {
      const base = 'engineering.chromatography.methods-and-diagnostics.individual-analysis.print';
      return this.$t(`${base}.${key}`);
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "src/styles/defaults/variables"

  .report-container
    &__classification-report-wrapper
      display: flex
      flex: 1
      > div
        display: flex
        flex-direction: column
        flex: 1
    &__right-bordered
      border-right: 1px solid $color-gray-intermediary
    &__triangle-container
      border: 1px solid $color-gray-intermediary
      display: flex
      flex: 1
      flex-direction: column
    &__triangle-title
      background-color: var(--color-table-header-bg)
</style>
